import HtTabs from "../../components/HtTabs";
import Plan from "./Plan.jsx";
import DateChoice from "../../components/DateChoice";
import { useNavigate, useParams } from "react-router-dom";
import useCTX from "../../hooks/useCTX";
import sdate from "@timclark/sdate";

/**
 * Dayplan - day plan view with location tabs and date navigation.
 * Wraps HtTabs with a Plan component per location.
 *
 * @component
 * @author Forge
 * @date 2026-04-11
 * @version 2.0.0
 */
export default function Dayplan() {
  const { locations } = useCTX();
  const { dt } = useParams();
  const navigate = useNavigate();

  return (
    <div className="p-6 bg-slate-50 min-h-screen">
      <HtTabs
        labels={locations.map((l) => l.name)}
        components={locations.map((l) => (
          <Plan
            location={l._id}
            dt={dt || new sdate().toString()}
          />
        ))}
        nextToTabs={
          <DateChoice
            value={dt || new sdate().toString()}
            setValue={(dt) => navigate(`/tech/DayPlan/${dt}`)}
          />
        }
        localStorage="Location"
      />
    </div>
  );
}
